module.exports = __webpack_public_path__ + "static/media/sad.3de520ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/sad.png
// module id = 1719
// module chunks = 0